var React = require('react');

function Multiply (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.816641 18.0698C0.559348 18.3271 0.414803 18.676 0.414803 19.0399C0.414803 19.4037 0.559348 19.7526 0.816641 20.0099C1.07393 20.2672 1.4229 20.4117 1.78677 20.4117C2.15063 20.4117 2.4996 20.2672 2.75689 20.0099L10.415 12.3498L18.0746 20.0085C18.3332 20.2583 18.6796 20.3965 19.0391 20.3933C19.3986 20.3902 19.7425 20.246 19.9967 19.9918C20.251 19.7376 20.3952 19.3937 20.3983 19.0342C20.4014 18.6748 20.2632 18.3284 20.0134 18.0698L12.3539 10.4111L20.0134 2.75236C20.2706 2.49509 20.4149 2.14624 20.4148 1.78253C20.4147 1.41883 20.2701 1.07008 20.0128 0.812994C19.7555 0.55591 19.4066 0.411554 19.0428 0.411682C18.6791 0.411811 18.3303 0.556414 18.0732 0.81368L10.415 8.47242L2.75552 0.81368C2.49691 0.563931 2.15054 0.425736 1.79101 0.428859C1.43149 0.431983 1.08758 0.576176 0.833344 0.830381C0.579112 1.08459 0.434905 1.42847 0.431781 1.78795C0.428657 2.14744 0.566866 2.49377 0.816641 2.75236L8.47617 10.4111L0.816641 18.0698Z","fill":"#474747"}));
}

Multiply.defaultProps = {"width":"24","height":"16","viewBox":"0 0 21 21","fill":"none"};

module.exports = Multiply;

Multiply.default = Multiply;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/multiply.svg
// module id = 1183
// module chunks = 0